<template>
<div>

  <div style="position: relative; min-height: 450px;">

    <gmap-map
        ref="vuegmap"
        id="trip-planner-map"
        v-if="googleMapsReady"
        :center="mapSettings.START_LOCATION"
        :zoom="mapSettings.START_ZOOMLEVEL"
        :options="{ streetViewControl: false, scaleControl: true, clickableIcons: false, styles: mapsStyles }"
        @center_changed="centerChangedHandler"
        @click="mapClickHandler">

      <!-- GPS geolocation -->
      <gmap-marker
          v-if="geolocation.enabled"
          :position="geolocation.position"
          :icon="iconGPSCircle">
      </gmap-marker>


      <!-- list origin/destination markers -->
      <gmap-marker
          v-for="(m, index) in startEndMarkers"
          :key="'point-'+index"
          :position="m.position"
          :icon="m.icon"
          :id="m.id"
          :title="m.title"
          :clickable="true"
          :draggable="true"
          @dragend="inputMarkerDragged($event.latLng, m.id, index)"
          @click="center=m.position">
      </gmap-marker>
      <gmap-marker
          v-for="(m, index) in startEndMarkers"
          :key="'label-'+index"
          :position="m.position"
          :icon="iconPointer"
          :z-index="999"
          :label="{
            text: (index === 0) ? 'From' : 'To',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold'
          }"
          :title="m.title"
          :clickable="true"
          :draggable="true"
          @dragend="inputMarkerDragged($event.latLng, m.id, index)"
          @click="center=m.position">
      </gmap-marker>

      <!-- list selected trip leg markers (circle icons) -->
      <gmap-marker
      v-for="(m, index) in tripMarkers"
        :key="'marker-circle-' + index"
        :position="m.position"
        :icon="m.icon"
        :clickable="true"
        atitle="'Leg ' + (index+1) + ') ' + m.title"
        aclick="legMarkerClickedHandler($event.latLng, index)">
      </gmap-marker>
      <!-- list selected trip leg markers (mode icons) -->
      <!-- <gmap-marker
      v-for="(m, index) in tripMarkers"
      v-if="m.iconMode"
      :zIndex="999"
      :key="index"
      :position="m.position"
      :icon="m.iconMode"
      :clickable="true"
      :title="'Leg ' + (index+1) + ') ' + m.title"
      @click="legMarkerClickedHandler($event.latLng, index)">
      </gmap-marker>  -->

      <!-- list selected trip leg shapes -->
      <gmap-polyline
      v-for="(p, index) in tripShapes"
      :key="'polyline-' + index"
      :options="p.options"
      :path="p.path">
      </gmap-polyline>


    </gmap-map>

  </div>

</div>
</template>

<script>
/*
Add mode markers (need svgs)
Add selected leg and highlight on map accordingly
*/
import { MAP as mapSettings } from '../config/'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'
import mixinMap from '../mixins/map'

export default {
  name: 'trip-planner-map',
  mixins: [mixinCommon, mixinFilters, mixinMap],
  props: ['isFuture'],
  data () {
    return {
      mapSettings: mapSettings,
      googleMapsReady: false,
      highlightColour: '#C44C1C',
      noneHighlightColour: '#502059',
      inputAddedViaMap: false
    }
  },
  watch: {
    selectedTripIndex (index) {
      console.log("WATCH selectedTripIndex", index)
      this.setMapBounds()
    },
    selectedLegIndex (index) {
      console.log("WATCH selectedLegIndex", index)
      if (!this.selectedTrip || this.selectedLegIndex < 0) {
        return
      }
      let map = this.$refs.vuegmap.$mapObject
      let leg = this.selectedTrip.legs[index]
      let zoom = map.getZoom();
      console.log("zoom", zoom)
      if (zoom < 12) {
        map.setZoom(14)
      }
      this.$refs.vuegmap.$mapObject.panTo({ lat: parseFloat(leg.from.lat), lng: parseFloat(leg.from.lon) })
      this.selectedLegIndex = -1
      // this.setMapBounds()
    },
    originLat (obj) {
      console.log("WATCH this.inputAddedViaMap", this.inputAddedViaMap)
      if (this.inputs.origin.lat === '' || this.inputAddedViaMap) {
        this.inputAddedViaMap = false
        return
      }
      this.$refs.vuegmap.$mapObject.panTo({ lat: parseFloat(this.inputs.origin.lat), lng: parseFloat(this.inputs.origin.lng) })
      this.inputAddedViaMap = false
    },
    destinationLat (obj) {
      if (this.inputs.destination.lat === '' || this.inputAddedViaMap) {
        this.inputAddedViaMap = false
        return
      }
      this.$refs.vuegmap.$mapObject.panTo({ lat: parseFloat(this.inputs.destination.lat), lng: parseFloat(this.inputs.destination.lng) })
      this.inputAddedViaMap = false
    }
  },
  computed: {
    geolocation () {
      return this.$store.getters['geoLocation/response'];
    },
    inputs () { // get router params and query
      return this.$store.getters['tripPlanner/inputs'];
    },
    originLat () { // get router params and query
      return this.$store.getters['tripPlanner/inputs'].origin.lat;
    },
    destinationLat () { // get router params and query
      return this.$store.getters['tripPlanner/inputs'].destination.lat;
    },
    summary () { // get router params and query
      return this.$store.getters['tripPlanner/tripSummary'];
    },
    routes () { // get router params and query
      return this.$store.getters['tripPlanner/tripRoutes'];
    },
    selectedTripIndex () {
      return this.$store.getters['tripPlanner/selectedTripIndex']
    },
    selectedLegIndex: {
      get () {
        return this.$store.getters['tripPlanner/selectedLegIndex']
      },
      set (index) {
        this.$store.commit('tripPlanner/SET_SELECTED_LEG_INDEX', index)
      }
    },
    // selectedLegIndex () {
    //   return this.$store.getters['tripPlanner/selectedLegIndex']
    // },
    selectedTrip () {
      if (this.selectedTripIndex < 0) {
        return false
      }
      if (this.routes.length < 1) {
        return false
      }
      if (!this.routes[this.selectedTripIndex]) {
        return false
      }
      return this.routes[this.selectedTripIndex]
    },
    startEndMarkers () {
      if (!this.inputs || !this.googleMapsReady) {
        return []
      }
      let markers = []
      if (this.inputs.origin.lat !== ''){
        markers.push({
          title: this.inputs.origin.name,
          id: 'origin',
          icon: Object.assign({}, this.iconBaseCircle, { fillColor: 'green', strokeColor: '#000' }),
          position: { lat: parseFloat(this.inputs.origin.lat), lng: parseFloat(this.inputs.origin.lng) }
        })
      }
      if (this.inputs.destination.lat !== ''){
        markers.push({
          title: this.inputs.destination.name,
          id: 'destination',
          icon: Object.assign({}, this.iconBaseCircle, { fillColor: 'red', strokeColor: '#000' }),
          position: { lat: parseFloat(this.inputs.destination.lat), lng: parseFloat(this.inputs.destination.lng) }
        })
      }
      // console.log("*markers", markers.map(x => x.position))
      return markers
    },
    tripMarkers () {
      if (!this.selectedTrip || !this.googleMapsReady) {
        return []
      }
      let markers = [];
      this.selectedTrip.legs.forEach((leg, i) => {
        let options = {
          icon: this.iconBaseCircle,
          position: { lat: parseFloat(leg.from.lat), lng: parseFloat(leg.from.lon) }
        }
        markers.push(options)
        if (i >= this.selectedTrip.legs.length-1) {
          let options = {
            icon: this.iconBaseCircle,
            position: { lat: parseFloat(leg.to.lat), lng: parseFloat(leg.to.lon) }
          }
          markers.push(options)
        }
      })
      // console.log("markers", markers.map(x => x.position))
      return markers
    },
    tripShapes () {
      if (!this.selectedTrip || !this.googleMapsReady) {
        return []
      }
      let polylines = [];

      // Define a symbol using SVG path notation, with an opacity of 1.
      let dashedLineSymbol = {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 1,
        scale: 3
      }
      this.selectedTrip.legs.forEach(leg => {
        let polyline = { options:{} };
        polyline.path = google.maps.geometry.encoding.decodePath(leg.legGeometry.points);
        polyline.options.geodesic = true;
        polyline.options.strokeColor = 'rgb(86, 184, 233)'
        polyline.options.strokeWeight = 4
        // polyline.options.strokeColor = (i === this.selectedLegIndex && !this.selectedLegIsLast) ? this.highlightColour : this.noneHighlightColour;
        // polyline.options.strokeWeight = (i === this.selectedLegIndex && !this.selectedLegIsLast) ? 4 : 4;
        polyline.options.strokeOpacity = 1;
        polyline.options.fillOpacity = 0.9;
        if (leg.mode.toLowerCase() == 'walk') {
          polyline.options.strokeOpacity = 0;
          polyline.options.fillOpacity = 0;
          polyline.options.fillColor = this.highlightColour;
          polyline.options.icons = [{
            icon: dashedLineSymbol,
            offset: '0',
            repeat: '10px'
          }];
        }

        // add all finish points in each leg
        polylines.push(polyline);
      })

      return polylines
    }
  },
  methods: {
   setMapBounds () {
    VueGoogleMaps.loaded
      .then(() => {
        if (this.$refs.vuegmap) {
          let bounds = new google.maps.LatLngBounds();
          this.tripMarkers.forEach(x => {
            bounds.extend(x.position)
          })
          if (this.tripMarkers.length > 0) {
            this.$refs.vuegmap.$mapObject.fitBounds(bounds)
          }
        }
      })
    },
    centerChangedHandler(map) {
      console.log("bounds changed");
      // this.$store.commit('map/SET_MAP_CENTER', {lat: map.lat(), lng: map.lng()} );
    },
    mapClickHandler(map) {
      if (this.selectedTripIndex < 0 && map.latLng) {
        let payload = {
          name: map.latLng.lat().toFixed(6) + "," + map.latLng.lng().toFixed(6),
          lat: map.latLng.lat(),
          lng: map.latLng.lng(),
        }
        let storeAction = (this.inputs.origin.lat === '') ? 'tripPlanner/SET_INPUT_ORIGIN' : 'tripPlanner/SET_INPUT_DESTINATION'
        if (this.inputs.origin.lat === '' || this.inputs.destination.lat === '') {
          this.$store.commit(storeAction, payload);
          this.inputAddedViaMap = true
        }
      }
    },
    // if origin/destination marker dragged then update store location
    inputMarkerDragged(position, id, index) {
      let storeAction = (id === 'origin') ? 'tripPlanner/SET_INPUT_ORIGIN' : 'tripPlanner/SET_INPUT_DESTINATION'
      this.$store.commit(storeAction, {
          name: position.lat().toFixed(6) + "," + position.lng().toFixed(6),
          lat: position.lat(),
          lng: position.lng()
      })
      this.inputAddedViaMap = true
      return;
    }

  },

  mounted () {
    VueGoogleMaps.loaded
      .then(() => {
        this.googleMapsReady = true
        setTimeout(() => { this.setMapBounds() }, 100) // set bounds but need to add timeout as mapObject isn't available
      })
  }
}
</script>

<style lang="scss" scoped>

#trip-planner-map, #trip-planner-street-view {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background-color: #ccc;
  // border:solid 1px #000;
}

.trip-notice {
  background-color: #eee;
  padding: 10px;
  font-size: 12px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerMap.vue